import Clipboard from 'clipboard'
import jQuery from 'jquery'
// clipboard button
jQuery(document).ready(function() {
    new Clipboard('.js_copy-to-clipboard');
});
